import { addMessageToChat } from '../commons/superconta-chat';

const RESALTADA = 'kanban-vista-btn--resaltada';
const TITILA = 'kanban-vista-btn--titila';
const RESALTANDO = 'kanban-column--resaltando';
const CLICK_KEY = '__titilarTareaClick';

type TitilarCard = HTMLElement & {
  [CLICK_KEY]?: (event: Event) => void;
};

function findTaskCard(id: string): TitilarCard | null {
  return document.querySelector<TitilarCard>(`[data-kanban-task-id="${id}"]`);
}

function columnOf(card: TitilarCard): HTMLElement | null {
  return card.closest('[data-kanban-column], .kanban-column');
}

function clearResalte(card: TitilarCard): void {
  const handler = card[CLICK_KEY];
  if (handler) {
    card.removeEventListener('click', handler);
    delete card[CLICK_KEY];
  }
  card.classList.remove(RESALTADA, TITILA);
  columnOf(card)?.classList.remove(RESALTANDO);
}

export function titilarTarea(columna: unknown, id: unknown): void {
  const taskId = String(id ?? '').trim();
  if (!taskId || typeof document === 'undefined') return;
  const card = findTaskCard(taskId);
  if (!card) return;
  clearResalte(card);
  columnOf(card)?.classList.add(RESALTANDO);
  card.classList.add(RESALTADA, TITILA);
  const onClick = () => {
    const descripcion = card.getAttribute('data-kanban-task-descripcion')?.trim() ?? '';
    clearResalte(card);
    addMessageToChat(
      `Ya seleccione para poder trabajar la Tarea ${taskId} ${descripcion} que está en Proceso, que puedo hacer ahora ?`,
    );
  };
  card[CLICK_KEY] = onClick;
  card.addEventListener('click', onClick);
}

if (typeof window !== 'undefined') {
  window.titilarTarea = titilarTarea;
}
